
import { Swiper, SwiperSlide } from "swiper/vue";

import "swiper/css";

import "swiper/css/navigation";
import { Navigation } from "swiper";

import { defineComponent } from 'vue';
import { useSwiper } from 'swiper/vue';
import ModalDialog from './components/Modal.vue';
export default defineComponent({
    components: {
        Swiper,
        SwiperSlide,
        ModalDialog,
    },
    setup() {
        const swiper = useSwiper();

        return {
            swiper,
        };
    },
    data() {
        return {
            swiperInstance: null,
            showModalSalita: false,
            showModalFunzionamento: false,
            showModalPainting: false,
            links: [
                {
                    title: 'Control Room segnalamento di terra',
                    eng: 'Trackside signalling Control Room',
                    key: 'control_room',
                    usdz: 'https://cloud-myarstudio-public.s3.eu-central-1.amazonaws.com/30b6e772-1574-4e1c-9302-96d10dda2cac/Playground/Products/b8606ead-bdf2-5bd5-800e-d905cd6402a6/default/03a27d38-bdaf-5142-b9bf-5051bb9df6bd/export/usdz/export.usdz',
                    glb: 'https://cloud-myarstudio-public.s3.eu-central-1.amazonaws.com/30b6e772-1574-4e1c-9302-96d10dda2cac/Playground/Products/b8606ead-bdf2-5bd5-800e-d905cd6402a6/default/03a27d38-bdaf-5142-b9bf-5051bb9df6bd/export/glb/export.glb'
                },
                {
                    title: 'Cabina di guida con segnalamento di bordo',
                    eng: 'Driver\'s cab with on-board signalling system',
                    key: 'cabin',
                    usdz: 'https://cloud-myarstudio-public.s3.eu-central-1.amazonaws.com/30b6e772-1574-4e1c-9302-96d10dda2cac/Playground/Products/b8606ead-bdf2-5bd5-800e-d905cd6402a6/default/6b7e7c32-3209-58a7-9286-3dabcbccd52d/export/usdz/export.usdz',
                    glb: 'https://cloud-myarstudio-public.s3.eu-central-1.amazonaws.com/30b6e772-1574-4e1c-9302-96d10dda2cac/Playground/Products/b8606ead-bdf2-5bd5-800e-d905cd6402a6/default/6b7e7c32-3209-58a7-9286-3dabcbccd52d/export/glb/export.glb'
                },
                {
                    title: 'Interni del treno Coradia Stream',
                    eng: 'Interior of Coradia Stream train',
                    key: 'interiors',
                    usdz: 'https://cloud-myarstudio-public.s3.eu-central-1.amazonaws.com/30b6e772-1574-4e1c-9302-96d10dda2cac/Playground/Products/b8606ead-bdf2-5bd5-800e-d905cd6402a6/default/d285824d-5561-5ae8-a2fd-a916c9f0742e/export/usdz/export.usdz',
                    glb: 'https://cloud-myarstudio-public.s3.eu-central-1.amazonaws.com/30b6e772-1574-4e1c-9302-96d10dda2cac/Playground/Products/b8606ead-bdf2-5bd5-800e-d905cd6402a6/default/d285824d-5561-5ae8-a2fd-a916c9f0742e/export/glb/export.glb'
                }
            ]
        }
    },
    methods: {
        setSwiper(swiper: any) {
            console.log('set instance');
            this.swiperInstance = swiper;
        },
        async showResults(mars_link: { usdz: string; glb: string; }) {
            
            if (!mars_link) return;
            // check if the browser supports the intent
            if (navigator.userAgent.match(/(iPhone|iPod|iPad)/)) {
                const link = document.createElement('a')
                link.rel = 'ar';
                link.href = mars_link.usdz;
                link.innerHTML = '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=" alt="">';
                document.body.appendChild(link)
                await link.click();
            } else {
                const link = document.createElement('a')
                link.href = 'intent://arvr.google.com/scene-viewer/1.0?file=' + mars_link.glb + '&mode=ar_preferred#Intent;scheme=https;package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;S.browser_fallback_url=https://developers.google.com/ar;end;'
                document.body.appendChild(link)
                await link.click();
            }
        },
    }
});
